import * as React from "react";
import EventDefinitionPriorityEnum, { getPriorityName } from "logic/alerts/EventDefinitionPriorityEnum";
import PriorityName from "components/events/events/PriorityName";
import EventTypeLabel from "components/events/events/EventTypeLabel";
import i18n from "i18n";
const extendPrioritySlices = (slices) => {
  const countsByValue = new Map(slices.map((slice) => [String(slice.value), slice.count]));
  return Object.keys(EventDefinitionPriorityEnum.properties).map((value) => {
    var _a;
    return {
      value,
      title: getPriorityName(value),
      count: (_a = countsByValue.get(String(value))) != null ? _a : 0
    };
  });
};
const extendTypeSlices = (slices) => {
  const countsByValue = new Map(slices.map((slice) => [String(slice.value), slice.count]));
  const values = [
    { value: "true", title: i18n.t("alerts_types.alert", { ns: "events" }) },
    { value: "false", title: i18n.t("alerts_types.event", { ns: "events" }) }
  ];
  return values.map(({ value, title }) => {
    var _a;
    return {
      value,
      title,
      count: (_a = countsByValue.get(value)) != null ? _a : 0
    };
  });
};
const sliceRenderers = {
  priority: {
    extendSlices: extendPrioritySlices,
    render: ({ value }) => /* @__PURE__ */ React.createElement(PriorityName, { priority: value })
  },
  alert: {
    extendSlices: extendTypeSlices,
    render: ({ value }) => /* @__PURE__ */ React.createElement(EventTypeLabel, { isAlert: String(value) === "true" })
  }
};
export default sliceRenderers;
